
export default {
  props: {
    value: {
      default: false,
    },
    checkboxId: {
      default: 'cbx-46',
    },
    required: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
}
